import { Link } from 'react-router-dom';
import { Sparkles, CreditCard, Clock } from 'lucide-react';
import { useSubscription, planSummary } from '@/hooks/useSubscription';

const TONE = {
  trial: 'border-amber-500/50 bg-amber-500/[0.08] text-amber-700 dark:text-amber-300',
  free: 'border-border bg-muted/60 text-muted-foreground',
  paid: 'border-emerald-500/40 bg-emerald-500/[0.07] text-emerald-700 dark:text-emerald-300',
};

const ICON = { trial: Clock, free: Sparkles, paid: CreditCard };

/** Always-visible plan / trial state. Click → plans & billing. */
export default function PlanBadge({ compact = false }) {
  const { sub } = useSubscription();
  const s = planSummary(sub);
  if (!s) return null;
  const Icon = ICON[s.tone];

  return (
    <Link
      to="/thesis/billing"
      title={`${s.label} · ${s.detail} — manage your plan`}
      data-testid="plan-badge"
      className={`hidden sm:inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px]
        font-semibold tracking-tight whitespace-nowrap transition-colors hover:brightness-105 ${TONE[s.tone]}`}
    >
      <Icon className="w-3 h-3 shrink-0" />
      <span data-testid="plan-badge-label">{s.label}</span>
      {!compact && (
        <span className="hidden lg:inline font-normal opacity-80">· {s.detail}</span>
      )}
    </Link>
  );
}
